







































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import DateClass from '@/app/module/date'
import Local from '@/app/module/local'
import GetMachineImgApi from '@/app/model/api/getMachineImgApi'
import Loading from '@/app/components/Common/Loading.vue'

@Component({
  components: {
    Loading
  }
})
export default class MachineList extends Vue {
  private constantValue: any
  private displayImg: string = require('@/assets/img/no_image.svg')
  private showImgLoading: boolean = false

  @Prop() private data!: any

  @Watch('data')
  changeData (data: any) {
    this.getDefaultImg()
  }

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.getDefaultImg()
  }

  private dateToStringYmd (date: any) {
    if (date !== null && date !== '') {
      let day = new Date(date)
      return DateClass.dateToStringYmd(day, '年月日')
    } else {
      return ''
    }
  }

  /* ステータスの判定 */
  private judgmentMachineIsValid (status: number) {
    switch (status) {
      case 0:
        return '利用可'

      case 1:
        return '利用不可'

      default:
        return '-'
    }
  }

  /* 機械タイプの判定 */
  private judgmentMachineType (type: number) {
    for (let i in this.constantValue.machine_types) {
      if (this.constantValue.machine_types[i].machine_type_id === type) {
        return this.constantValue.machine_types[i].machine_type_name
      }
    }
  }

  private async getDefaultImg () {
    if (this.data.image_path !== null && this.data.image_path !== '') {
      this.showImgLoading = true
      const result = await GetMachineImgApi.getMachineImgData(this.data.machine_id)
      // resultがオブジェクト型の場合、エラーで画像が存在しないため「登録なし」を表示
      if (typeof result === 'object') {
        this.displayImg = require('@/assets/img/no_image.svg')
      } else {
        this.displayImg = String(result)
      }
      this.showImgLoading = false
    } else {
      this.displayImg = require('@/assets/img/no_image.svg')
    }
  }

  private showImgModal () {
    if (this.data.image_path !== null) {
      this.$emit('show-img-modal', String(this.data.machine_id))
    }
  }
}
